import { useTranslation } from "@sagot/i18n";
import { Field, Input, Textarea } from "@sagot/ui";
import { ActionToggles, AudienceEditor, StarterEditor } from "./draft-editors";
import { PERSONA_MAX_LENGTH, type SetupConfig } from "./setup-config";
import { StageEditor } from "./stage-editor";

interface DraftFieldsProps {
  config: SetupConfig;
  onChange: (patch: Partial<SetupConfig>) => void;
}

/** Everything below name + purpose in the step-3 editor (all editable, nothing saved until confirm). */
export function DraftFields({ config, onChange }: DraftFieldsProps) {
  const { t } = useTranslation();
  return (
    <>
      <Field label={t("onboarding.configure.instructions")} hint={t("onboarding.configure.instructionsHelp")} error={config.instructions.length > PERSONA_MAX_LENGTH ? t("onboarding.configure.instructionsTooLong") : undefined}>
        <Textarea className="font-mono text-[12.5px]" rows={7} value={config.instructions} onChange={(e) => { onChange({ instructions: e.target.value }); }} />
      </Field>
      <StarterEditor questions={config.starter_questions} onChange={(starter_questions) => { onChange({ starter_questions }); }} />
      <AudienceEditor labels={config.audience_labels} served={config.audiences} onLabels={(audience_labels) => { onChange({ audience_labels }); }} onServed={(audiences) => { onChange({ audiences }); }} />
      <StageEditor stages={config.lead_stages} onChange={(lead_stages) => { onChange({ lead_stages }); }} />
      <ActionToggles actions={config.actions} onChange={(actions) => { onChange({ actions }); }} />
      <Field label={t("onboarding.configure.welcome")}>
        <Input value={config.welcome_message} maxLength={500} onChange={(e) => { onChange({ welcome_message: e.target.value }); }} />
      </Field>
      <Field label={t("onboarding.configure.topics")} hint={t("onboarding.configure.topicsHint")}>
        <Textarea rows={3} value={config.blocked_topics} onChange={(e) => { onChange({ blocked_topics: e.target.value }); }} />
      </Field>
    </>
  );
}
